/*
*修改订单地址数据存储
*/
// 仓库
const state = {
    fixAddressIndex:null,//要修改的地址下标
    fixAddressData:{},//正在修改的地址信息
    shippingInfo:[],//装货地址
    receivingInfo:[],//卸货地址
};
const getter = {};

const actions = {
    // 赋值要修改的地址下标
    setFixAddressIndex({commit},value){
        commit('SET_ADDRESS_INDEX',value);
    },
    // 赋值正在修改的地址信息
    setFixAddress({commit},value){
        commit('SET_ADDRESS_DATA',value);
    },
    // 装货地址赋值
    setShippingInfo({commit},value){
        commit('SET_SHIP',value);
    },
    // 卸货地址赋值
    setReceivingInfo({commit},value){
        commit('SET_RECE',value);
    }
}
const mutations = {
    SET_ADDRESS_INDEX(state,value){
        state.fixAddressIndex = value;
    },
    SET_ADDRESS_DATA(state,value){
        state.fixAddressData = value;
    },
    SET_SHIP(state,value){
        state.shippingInfo = value;
    },
	SET_RECE(state,value){
        state.receivingInfo = value;
    }
}

export default{
	state,
	getter,
	actions,
	mutations
}